'use strict'

import axios from 'axios';

const zipCodeVerifierUrl = 'https://location.melhorenvio.com';

const baseUrl = '/api/v2/integrations/spreadsheets';

const headers = {
  'accept':'application/json',
  'content-type': 'application/json'
};

export default class Spreadsheets {
  static async retrieveTemplates(callback) {
    await axios.get(`${ baseUrl }/templates`, headers)
               .then(async response => await callback(response))
               .catch(err => console.warn(err));
  };

  static async retrieveShippingServices(callback, templateId) {
    await axios.get(`${ baseUrl }/templates/${ templateId }/services`, headers)
               .then(async response => await callback(response))
               .catch(error => console.warn(error));
  };

  static async retrieveSpreadsheets (param, callback) {
    let url = baseUrl;

    if (param) {
      param = param.split('?').slice(-1);

      url += '?' + param;
    }

    await axios.get(url, headers)
     .then(async response => await callback(response))
     .catch(error => console.warn(error));
  };

  static async verifyZipCode (zipCode) {
    localStorage && localStorage.clear()
    return await axios.get(`${ zipCodeVerifierUrl }/${ zipCode }`);
  };

  static createSpreadsheet(payload) {
    localStorage && localStorage.clear();
    return axios.post( baseUrl ,payload, headers )
                .catch( error => console.warn(error));
  };

  static updateSpreadsheet(payload, spreadsheetId) {
    localStorage && localStorage.clear();
    return axios.patch(`${baseUrl}/${spreadsheetId}` ,payload, headers )
                .catch( error => console.warn(error));
  };

  static deleteSpreadsheet(spreadsheetId) {
    localStorage && localStorage.clear();
    return axios.delete(`${baseUrl}/${spreadsheetId}`);
  };
}
